<div class="all-content">
    <div class="row">
        <div class="item">
            <span> {{ getLanguages('businessSolution/modal/phase/nameOportunity') }} </span>
            <input disabled type="text" [(ngModel)]="parameters.item.label" class="input-disabled">
        </div>
        <div class="item td-date">
            <span> {{ getLanguages('businessSolution/modal/phase/entryDate') }} </span>
            <div (click)="focusInput($event)" [ngClass]="!parameters.isEdit ? 'input-disabled' : 'div'">
                <input matInput [(ngModel)]="parameters.item.phase.entryDate" [disabled]="!parameters.isEdit"
                    [matDatepicker]="picker" (keypress)="validateDateInput($event)"
                    (input)="onDateInputChange($event)" (blur)="onDateBlur($event)" [min]="minDate">
                <mat-datepicker #picker></mat-datepicker>
                <button [disabled]="!parameters.isEdit" [ngClass]="!parameters.isEdit ? 'disabled-icon' : 'icon'"
                    (click)="picker.open()">
                    <i class="fas fa-calendar-days"></i>
                </button>
            </div>
        </div>
        <div class="item">
            <span> {{ getLanguages('businessSolution/modal/phase/weeks') }} </span>
            <input disabled type="text" [ngModel]="getWeeks()" class="input-disabled">
        </div>
    </div>
    <div class="row">
        <div class="item">
            <span> {{ getLanguages('businessSolution/modal/phase/organizationResponsible') }} </span>
            <button class="select-nav" [matMenuTriggerFor]="selectOrganization" [disabled]="!parameters.isEdit" [ngClass]="!parameters.isEdit ? 'disabled no-pointer' : '' ">
                <span>
                    {{ parameters?.item?.phase?.organizationResponsible ? parameters?.item?.phase?.organizationResponsible : getLanguages('search')  }}
                </span>
                <i class="fas fa-caret-down" *ngIf="parameters.isEdit"></i>
            </button>
            <mat-menu #selectOrganization="matMenu">
                <div class="menu">
                    <div class="input" (click)="$event.stopPropagation()" >
                        <input type="text" [(ngModel)]="searchResponsibleOrganization" placeholder="{{ getLanguages('search') }}">
                        <i class="fa-solid fa-magnifying-glass"></i>
                    </div>
                    <div class="scroll">
                        <ng-container *ngFor="let organization of organizationResponsibleArray">
                            <ng-container *ngIf="organization?.name?.includes(searchResponsibleOrganization.toLowerCase())">
                                <div class="item-menu" (click)="choseResponsibleOrganization(organization)">
                                    <span [ngClass]="{'valid-span' : organization.name == parameters?.item?.phase?.organizationResponsible}">
                                        {{ organization.name }}
                                    </span>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </mat-menu> 
        </div>
    </div>
    <div class="row row-end">
        <div class="button-upload" (click)="newWeek()" [ngClass]="!parameters.isEdit ? 'disabled' : 'pointer'">
            {{ getLanguages('businessSolution/modal/phase/addWeek') }}
        </div>
    </div>
    <div class="no-data" *ngIf="!isData()">
        <div class="circle">
            <i class="fas fa-exclamation"></i>
        </div>
        {{ getLanguages('errors/noData') }}
    </div>
    <div class="row" *ngIf="isData()">
        <p-table *ngIf="getDisplayedRows().length !== 0" [value]="getDisplayedRows()" class="table-project">
            <!-- [sortField]="'updated_date'" [sortOrder]="1"> -->
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="date" class="td-15">
                        <span> {{ getLanguages('businessSolution/modal/phase/date') }} </span>
                        <!-- <p-sortIcon field="date"></p-sortIcon> -->
                    </th>
                    <th pSortableColumn="week" class="td-15">
                        <span> {{ getLanguages('businessSolution/modal/phase/week') }} </span>
                        <!-- <p-sortIcon field="week"></p-sortIcon> -->
                    </th>
                    <th pSortableColumn="phase" class="td-20">
                        <span> {{ getLanguages('businessSolution/modal/phase/phase') }} </span>
                        <!-- <p-sortIcon field="phase"></p-sortIcon> -->
                    </th>
                    <th pSortableColumn="observation" class="td-35">
                        <span> {{ getLanguages('businessSolution/modal/phase/observation') }} </span>
                        <!-- <p-sortIcon field="observation"></p-sortIcon> -->
                    </th>
                    <th pSortableColumn="percentage" class="td-15">
                        <span> {{ getLanguages('businessSolution/modal/phase/percentage') }} % </span>
                        <!-- <p-sortIcon field="percentage"></p-sortIcon> -->
                    </th>
                    <th class="td-15">
                        <span> {{ getLanguages('businessSolution/modal/phase/action') }} </span>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                <tr>
                    <td class="td-15">
                        <textarea [disabled]="!parameters.isEdit" [(ngModel)]="row.date"></textarea>
                    </td>
                    <td class="td-15">
                        <textarea [disabled]="!parameters.isEdit" [(ngModel)]="row.week"></textarea>
                    </td>
                    <td class="td-20">
                        <button class="button-menu-table" [disabled]="!parameters.isEdit"
                            [ngClass]="!parameters.isEdit ? 'no-pointer' : ''" [matMenuTriggerFor]="phase">
                            <span>
                                {{ row.phase ? getNameBySlug(row.phase) : getLanguages('select') }}
                            </span>
                            <i class="fa-solid fa-caret-down" *ngIf="parameters.isEdit"></i>
                        </button>
                        <mat-menu #phase="matMenu">
                            <div class="menu">
                                <div class="input" (click)="$event.stopPropagation()">
                                    <input type="text" [(ngModel)]="searchPhase"
                                        placeholder="{{ getLanguages('search') }}">
                                    <i class="fa-solid fa-magnifying-glass"></i>
                                </div>
                                <div class="scroll">
                                    <ng-container *ngFor="let item of phaseArray">
                                        <ng-container
                                            *ngIf="getNames(item?.name)?.toLowerCase().includes(searchPhase?.toLowerCase())">
                                            <div class="item-menu"
                                                (click)="choseItemSelect('phase', item, row)">
                                                <span
                                                    [ngClass]="getNames(item?.name) == row?.name ? 'valid-span' : 'invalid-span'">
                                                     {{ getNames(item?.name) }}
                                                </span>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </div>
                        </mat-menu>
                    </td>
                    <td class="td-35">
                        <textarea 
                            [disabled]="!parameters.isEdit" 
                            [(ngModel)]="row.observation"
                            (input)="adjustTextareaHeight($event)"
                        ></textarea>
                    </td>
                    <td class="td-15">
                        <input type="number" [disabled]="!parameters.isEdit" [(ngModel)]="row.percentage" (blur)="checkValuePercentage(row)">
                    </td>
                    <td class="td-15">
                        <div class="align-center" [ngClass]="!parameters.isEdit ? 'disabled-icon' : 'icon'">
                            <i class="fas fa-trash pointer" (click)="deleteWeek(row.uuid)"
                                [ngClass]="!parameters.isEdit ? 'disabled-icon no-pointer' : 'icon'"></i>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <div class="div-paginator" *ngIf="isData()">
        <div class="paginator">
            <span>
                {{ getLanguages('businessSolution/modal/strategy/itensPage') }}
            </span>
            <button [matMenuTriggerFor]="menu" class="itens-per-page">
                {{ getItemsPerPage() }}
            </button>
            <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="choseItemsPage(5)">5</button>
                <button mat-menu-item (click)="choseItemsPage(10)">10</button>
            </mat-menu>
            <span>
                {{ getLanguages('businessSolution/modal/strategy/totalPages') }}
            </span>
            <span class="totalPages">
                {{ getTotalPages()}}
            </span>
            <button [ngClass]="getCurrentPages() === 1 ? 'disabled-arrow' : 'arrow'"
                [disabled]="getCurrentPages() === 1" (click)="onPageChange(getCurrentPages() - 1, 'strategy')">
                <i class="fa-solid fa-angle-left"></i>
            </button>
            <input type="number" [ngModel]="getCurrentPages()" (blur)="checkValue()">
            <button [ngClass]="getCurrentPages() == getTotalPages() ? 'disabled-arrow' : 'arrow'"
                [disabled]="getCurrentPages() == getTotalPages()"
                (click)="onPageChange(getCurrentPages() + 1, 'strategy')">
                <i class="fa-solid fa-angle-right"></i>
            </button>
        </div>
    </div>
</div>

<div class="background-modals" *ngIf="createResponsibleOrganogram">
    <div class="modal-create-type">
      <div class="modal-create-top">
        <div class="modal-create-toggle"></div>
  
        <div class="div-icon-button">
          <div class="save" (click)="setCorporationResponsibleOrganization()">
            {{ getLanguages('save')}}
          </div>
          <i class="fas fa-xmark" (click)="createResponsibleOrganogram = false"></i>
        </div>
        </div>
  
      <div class="modal-create-row">
        <div class="modal-create-title">
          {{ getLanguages('businessSolution/modal/rules/titleNewResponsibleOrganization') }}
        </div>
      </div>
  
      <div class="modal-create-row">
        <div class="modal-create-item">
          <span> {{ getLanguages('businessSolution/modal/rules/titleNewResponsibleOrganization') }}</span>
          <input type="text" [(ngModel)]="newOrganizationResponsible.name">
        </div>
      </div>
    </div>
</div>